import { guardLoader, orderAheadSetupGate } from "./guards";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import { OrderAheadOverview, orderAheadOverviewLoader } from "./OrderAheadOverview";

const OrderAheadIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/order-ahead") {
    navigate(`/order-ahead/overview`);
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export const orderAheadRouter = {
  path: "/order-ahead",
  id: "order-ahead",
  element: <OrderAheadIndex />,
  handle: {
    crumb: () => <Breadcrumb name="Order Ahead" href="/order-ahead/overview" />,
  },
  children: [
    {
      path: "overview",
      id: "order-ahead-overview",
      element: <OrderAheadOverview />,
      loader: guardLoader(orderAheadSetupGate, orderAheadOverviewLoader),
    },
  ],
};
